// extracted by mini-css-extract-plugin
export default {"modalError":"ModalError_modalError__hOX4g"};